import { SxProps, Theme } from '@mui/material/styles';
import { ReactNode } from 'react';

import { Spacing } from '../theme/type';

export enum HxType {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
}

export type HxProps = {
  bold?: boolean;
  center?: boolean;
  children?: ReactNode;
  color?: string;
  margin?: Spacing;
  position?: 'static';
  sx?: SxProps<Theme>;
  type: HxType;
  uppercase?: boolean;
};

export type HeadingProps = Omit<HxProps, 'type'>;
